﻿import {Core} from "../Base/Core";
import {GameManager} from "../Game/GameManager";
import {UISprite} from "./Tools/Base/UISprite";
import {UIButton} from "./Tools/Base/UIButton";
import {UIImage} from "./Tools/Base/UIImage";
import {UIAttention} from "./UIAttention";

export class EpochListItem extends UISprite {

    constructor(epoch) {
        super();
        this.epoch = epoch; // EpochData

        this.btn = this.addChild(new UIButton("button-small-passive"));
        this.btn.anchor.set(0.5, 0.45);

        this.epochIconImage = this.btn.addChild(new UIImage(`epochs/icons/${epoch.id}`));
        this.epochIconImage.scale.set(this.btn.texture.width * 0.5 / this.epochIconImage.texture.width);

        this.attention = this.addChild(new UIAttention());

        this.arrowImage = this.addChild(new UIImage("arrow"));

        this.btn.on("pointertap", () => {
            GameManager.gameView.SelectEpoch(epoch.id, true, 0);
        });
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);

        let rect = parentRect.clone();
        rect.x = rect.y = 0;

        this.btn.fitRect(rect);

        let arrowSize = rect.width * 0.5;
        this.arrowImage.fitRect(new PIXI.Rectangle(
            -arrowSize, (rect.height - arrowSize) * 0.5, arrowSize, arrowSize
        ));

        this.attention.fitLayout(new PIXI.Rectangle(rect.width * 0.1, rect.height * 0.1, 1, 1));
    }

    Update() {
        this.SetActive(Core.Player.PlanetsSave.CurrentPlanet && Core.Player.PlanetsSave.CurrentPlanet.epochs.includes(this.epoch.id));

        this.attention.SetActive(GameManager.gameController && GameManager.gameController.epochById
            && !GameManager.gameController.epochById.get(this.epoch.id).EnoughSpaceForSpawn
        );

        if (GameManager.gameView) {
            let current = GameManager.gameView.selectedEpochId == this.epoch.id;
            this.arrowImage.SetActive(current);
            this.btn.interactive = !current;
            this.btn.setImage(current ? "button-small-active" : "button-small-passive");
        }
    }
}

